import { FormControl } from 'baseui/form-control'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import { formControlOverrides } from '@/shared/components/SDComponentsNewDesign/styled-components'
import CopyEndEnhancer from '@/shared/components/SDComponentsNewDesign/CopyEndEnhancer/CopyEndEnhancer'
import useFiscalCode from './useFiscalCode'

const FiscalCode = () => {
  const { taxIdCode, label, error, isEditable, status, onBlur, hidden } = useFiscalCode()

  if (hidden) {
    return null
  }

  return (
    <FormControl error={error} overrides={formControlOverrides}>
      <SDInput
        id='input-customer-tax-id-code'
        label={label}
        currentValue={taxIdCode}
        disabled={isEditable === false}
        error={!!error}
        overrides={undefined}
        status={status}
        endEnhancer={<CopyEndEnhancer value={taxIdCode} />}
        outerOnchange={undefined}
        onBlur={onBlur}
      />
    </FormControl>
  )
}

export default FiscalCode
